import React, { Component } from "react";
import { Card, Icon, Tag, Radio } from "antd";
import WizardFooter from "./wizard-footer";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import ZillowHomeValueContainer from "./zillow-home-value-container";

const RadioGroup = Radio.Group;

class Step extends Component {
  render() {
    const { wizard, updateField } = this.props;

    return (
      <div>
        <Card
          className="wizardCard"
          bordered={false}
          title={
            <div>
              <Tag color="#87d068">
                <Translate text={wizard.status} />
              </Tag>
              <Translate text={`Primary Home`} />
            </div>
          }
        >
          <Card
            title={<Translate text={`"Do you fully own or are you in the process of purchasing your primary residence?"`} />}
            className="wizardBox"
            type="inner"
            style={{ textAlign: "center" }}
          >
            <RadioGroup
              value={wizard.home_toggle}
              onChange={(e) => updateField("home_toggle", e.target.value)}
            >
              <Radio value="1" className="btnYes">
                <Icon
                  type="like-o"
                  style={{ marginRight: 10, color: "#388E3C" }}
                />{" "}
                <Translate text={`Yes`} />
              </Radio>
              <Radio value="0" className="btnNo">
                <Icon
                  type="dislike-o"
                  style={{ marginRight: 10, color: "#FF3D00" }}
                />{" "}
                <Translate text={`No`} />
              </Radio>
              <Radio value="2" className="btnOption">
                <Icon
                  type="home"
                  style={{ marginRight: 10, color: "#424242" }}
                />{" "}
                <Translate text={`Rent`} />
              </Radio>
            </RadioGroup>
          </Card>

          {wizard.home_toggle === "1" ? (
            <ZillowHomeValueContainer {...this.props} />
          ) : null}

          <Card className="wizardBox center-align didYouKnowBox" type="inner">
            <h2>
              <Translate text={`DID YOU KNOW`} />
            </h2>
            <p>
              <Translate
                text={`The equity in your home may be at risk in the event of a liability lawsuit.`}
              />
            </p>
          </Card>

          <WizardPager
            updateField={updateField}
            stepIndexPages={[4, 5, 6, 7, 8]}
            wizardStepIndex={wizard.stepIndex}
          />
        </Card>
        <WizardFooter {...this.props} />
      </div>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step3.js